export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const USER_LOADED = "USER_LOADED";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const AUTH_ERROR = "AUTH_ERROR";
export const CARD_SUCCESS = "CARD_SUCCESS";
export const CARD_FAILURE = "CARD_SUCCESS";
export const GET_CARDS = "GET_CARDS";
export const UPDATE_CARD = "UPDATE_CARD"
 export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const DELETE_CARD = "DELETE_CARD";
export const GET_ORDERS = "GET_ORDERS";
// export const AXIOS_BASE_URL = "http://localhost:8005/";
export const AXIOS_BASE_URL = "https://api.vyldfyre.com/";
 export const BASE_URL = "https://admin.vyldfyre.com/";

// export const BASE_URL = "http://localhost:3001/";